import { Video as LucideIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { useNavigate } from 'react-router-dom';

interface StatItem {
  label: string;
  value: number | string | null | undefined;
  highlight?: boolean;
}

interface CategoryStatsCardProps {
  title: string;
  icon: LucideIcon;
  color: string;
  stats: StatItem[];
  link?: string;
}

export function CategoryStatsCard({ title, icon: Icon, color, stats, link }: CategoryStatsCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <Card
      className={`p-5 hover:shadow-card-hover hover:-translate-y-0.5 group transition-all duration-200 ease-smooth ${link ? 'cursor-pointer' : ''}`}
      onClick={handleClick}
    >
      <div className="flex items-center gap-3 mb-4">
        <div className={`p-2.5 rounded-xl ${color} bg-opacity-10 dark:bg-opacity-5 transition-all duration-200 group-hover:scale-110`}>
          <Icon className={`h-5 w-5 ${color}`} />
        </div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-50 tracking-tight">{title}</h3>
      </div>

      <div className="space-y-2.5">
        {stats.map((stat, index) => {
          const numValue = typeof stat.value === 'number' ? stat.value : parseInt(stat.value || '0');
          const safeValue = isNaN(numValue) ? 0 : numValue;

          return (
            <div key={index} className="flex items-center justify-between">
              <span className="text-sm text-gray-500 dark:text-gray-400">{stat.label}</span>
              <span className={`text-sm font-semibold ${stat.highlight ? 'text-primary-600 dark:text-primary-400' : 'text-gray-900 dark:text-gray-200'}`}>
                {safeValue.toLocaleString('pt-BR')}
              </span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
